<template>
	<modal :name="modalName" width="590" :clickToClose="false" @opened="handleModalOpened">
    <div style="position: relative;">
      <button role="button" class="button-close" @click="hideModal">
        <img src="/assets/app/class/icon-close.svg">
      </button>
        <canvas id="result-canvas" v-if="type === 'success'"></canvas>
        <div class="result-modal-header">
            <page-title>{{ modalTitle }}</page-title>
        </div>
        <div class="result-modal-content">
            <p class="modal-description">{{ resultDescription }}</p>
            <img class="modal-icon" :src="modalIconPath">
        </div>
        <div class="result-modal-footer">
            <primary-button @click="handleClickFooterButton">
                {{ buttonTitle }}
                <a class="email-link" href="mailto:support@readtheory.org?subject=Contact%20our%20support" v-if="type === 'failed'"></a>
            </primary-button>
        </div>
    </div>
    </modal>
</template>

<script>

  import {RTFacebookPixel} from '../../../common/fbpixel';

  const MODAL_TYPE_SUCCESS = 'success';

  import Vue from 'vue';
  import { mapState, mapMutations } from 'vuex';
  import VueConfetti from 'vue-confetti';
  import { BASE_PATH } from 'config';
  import PageTitle from '../common/PageTitle.vue';
  import PrimaryButton from '../common/PrimaryButton.vue';
  import { saveState } from '../localstorage';

  Vue.use(VueConfetti);

  export default {
    props: ['type', 'title', 'body'],
    components: {
      PageTitle,
      PrimaryButton
    },
    computed: {
        ...mapState('teacher', ['signupStatus']),
        modalName() {
            return !this.title ? 'subscription-result-modal' : 'subscription-result-modal-2';
        },
        modalTitle() {
            if (this.type === MODAL_TYPE_SUCCESS) {
                return 'Welcome to ReadTheory Premium!';
            } else {
                return this.title || 'Oops... something is wrong';
            }
        },
        resultDescription() {
            if (this.type === MODAL_TYPE_SUCCESS) {
                return 'Subscription was activated for our premium plan, Thank You!';
            } else {
                return this.body || 'Transaction was canceled, please retry or reach out to our support at support@readtheory.org';
            }
        },
        modalIconPath() {
            if (this.type === MODAL_TYPE_SUCCESS) {
                return '/assets/app/class/icon-sub-success.svg';
            } else {
                return '/assets/app/class/icon-sub-failure.svg';
            }
        },
        buttonTitle() {
            if (this.type === MODAL_TYPE_SUCCESS) {
                return 'Back To ReadTheory';
            } else {
                return 'Contact Our Support';
            }
        }
    },
    watch: {
        'type'(newVal) {
            if (newVal) {
                this.$modal.show(this.modalName);
            }
        }
    },
    methods: {
        ...mapMutations('teacher', ['updateSignupStatus', 'updateSignupABTest']),
        hideModal() {
          this.handleClickFooterButton();
        },
        handleModalOpened() {
            if (this.type === MODAL_TYPE_SUCCESS) {
                RTFacebookPixel.reportPurchaseEvent();
                this.$confetti.start({
                    canvasId: 'result-canvas',
                    defaultDropRate: 3,
                    defaultSize: 2,
                    particles: [
                        {
                            type: 'circle'
                        },
                        {
                            type: 'rect'
                        }
                    ],
                });
            }
        },
        handleClickFooterButton() {
            if (this.type === MODAL_TYPE_SUCCESS) {
                this.$confetti.stop();
            }

            this.$modal.hide(this.modalName);
            this.$emit('close');

            if (!this.title) {
                if (!this.signupStatus) {
                    history.replaceState(null, null, location.href.replace(/[\?&]sub=[^&]+/, '').replace(/^&/, '?'));
                } else {
                    history.replaceState(null, null, BASE_PATH + '/app/teacher/class/list');
                    this.updateSignupStatus(null);
                    this.updateSignupABTest(null);
                    saveState(this.$store.state);
                }
            }

            if (this.type === MODAL_TYPE_SUCCESS) {
							// remove sub query from url to avoid that popup glitches without closing after subscription success
							// this issue appears when start creating new activity from class page and complete flow including subscription activation
							const newUrlWithoutSub = location.origin + location.pathname + location.search.substring(0, location.search.indexOf('sub'));
							history.replaceState(null, null, newUrlWithoutSub);
							location.reload();
            }
        }
    }
  }

</script>

<style scoped lang="scss">

    @import '../common/variables';

    .v--modal-overlay[data-modal="subscription-result-modal-2"] {
      ::v-deep(.v--modal-box) {
            left: calc((100vw - 590px) / 2) !important;
        }
    }

    .v--modal-overlay[data-modal^="subscription-result-modal"] {
        background: rgba(20, 32, 53, 0.85) !important;
        z-index: 9999999999;
      ::v-deep(.v--modal-box) {
            top: 70px !important;
            height: auto !important;
            border-radius: 12px;
            padding: 64px 32px;
		}
    }

    .result-modal-header {
        .page-title {
            margin: 0;
            padding-bottom: 16px;
            line-height: 44px;
            text-align: center;
            color: $title-dark-grey;
        }
    }

    .result-modal-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        .modal-description {
            margin: 0;
            line-height: 24px;
            text-align: center;
        }
        .modal-icon {
            padding: 52px 0;
        }
    }

    .result-modal-footer {
        text-align: center;
        .primary-button {
            position: relative;
            margin: 0;
            padding: 13px 52px;
            .email-link {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
        }
    }

    .button-close {
      position: absolute;
      top: -43px;
      right: 0;
      border: 0;
      background: transparent;
      font-weight: bold;
      font-size: 18px;
      color: #555;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }
    }
</style>
